const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Buttons/IconDownOrUp.tsx';
import { Icon } from '@mui/material';
import * as React from 'react';
import { css, cx } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';

const iconStyle = css`
    display: flex;
    align-self: center;
    margin-top: 6px;
`;

const getIconClasses = () => ({
    muiIconNoHover: css`
        color: ${theme.palette.secondary.main};
    `,
});

const disabled = css`
    color: lightgrey;
`;

export interface IProps {
    disabled: boolean;
}

export const IconUp = (props: IProps) => <IconContainer icon={'icons8-chevron-up'} disabled={props.disabled} />;
export const IconDown = (props: IProps) => <IconContainer icon={'icons8-chevron-down'} disabled={props.disabled} />;

interface IconProps {
    icon: string;
    disabled: boolean;
}

export const IconContainer = (props: IconProps) => {
    const classes = getIconClasses();
    return (
        <div className={iconStyle}>
            <div>
                {/* component = "span" fixed a react warning : react_devtools_backend.js:2430 Warning: validateDOMNesting(...): <button> cannot appear as a descendant of <button>*/}
                <Icon className={cx(props.icon, classes.muiIconNoHover, props.disabled && disabled)} component="span" />
            </div>
        </div>
    );
};
